import { EntityRequestCostsacct } from "../../entity/EntityRequestCostsacct";

export class DtoRequestCostsacctsPostRes extends EntityRequestCostsacct {}
